export const parameterizeURL = (url, params) => {
  for (const paramsKey in params) {
    if (params[paramsKey]) {
      const sep = url.includes('?') ? '&' : '?';
      url = url + sep + paramsKey + '=' + params[paramsKey];
    }
  }
  return url;
};
